import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className='footer'>
      <p className='footer__text'>© Natalie Clamp, 2019</p>
    </div>
  );
};

export default Footer;
